var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import sortBy from 'lodash/sortBy';
import { formatAmount } from "../lib/formatAmount";
import moment from "moment";
export default {
    getReservedAccounts: function (state) {
        return state.reservedAccount ? __assign(__assign({}, state.reservedAccount), { reserved: sortBy(state.reservedAccount.reserved || [], [function (o) { return !o.is_primary; }, 'status']) }) : state.reservedAccount;
    },
    getCreateReserve: function (state) {
        return state.createReserve;
    },
    getReservedAccountsDetails: function (_a) {
        var reservedAccountsDetails = _a.reservedAccountsDetails;
        return reservedAccountsDetails && reservedAccountsDetails.payout_count ? __assign(__assign({}, reservedAccountsDetails), { account_funding_value: formatAmount(reservedAccountsDetails.account_funding_value), payout_value: formatAmount(reservedAccountsDetails.payout_value), gamma_vnuban_balance: formatAmount(reservedAccountsDetails.gamma_vnuban_balance) }) : reservedAccountsDetails;
    },
    getDashboardBankAccounts: function (state) {
        return state.dashboardBankAccounts ? __assign(__assign({}, state.dashboardBankAccounts), { accounts: sortBy(state.dashboardBankAccounts['Merchant_Accounts'] || [], [function (o) { return !o.is_primary; }, 'status']) }) : state.dashboardBankAccounts;
    },
    getReservedPayouts: function (state) {
        console.log(state.ReservedAccountPayouts, 'state.ReservedAccountPayouts');
        if (!state.ReservedAccountPayouts || state.ReservedAccountPayouts.loading && state.ReservedAccountPayouts.error) {
            return {
                loading: true
            };
        }
        var _a = state.ReservedAccountPayouts, funding_history = _a.funding_history, payout_transactions = _a.payout_transactions, rest = __rest(_a, ["funding_history", "payout_transactions"]);
        console.log(state.ReservedAccountPayouts, 'state.ReservedAccountPayouts');
        // reformat naming for payouts
        var payouts = payout_transactions && payout_transactions.length
            ? payout_transactions.map(function (_a) {
                var beneficiary_phone_number = _a.beneficiary_phone_number, createdAt = _a.createdAt, amount = _a.amount, others = __rest(_a, ["beneficiary_phone_number", "createdAt", "amount"]);
                return (__assign(__assign({}, others), { phone: beneficiary_phone_number || 'Not Available', closingBalance: "".concat(formatAmount(amount)), date: moment(createdAt).format("lll"), amount: formatAmount(amount) || amount }));
            })
            : [];
        // // reformat naming for funding history
        var fundingHistory = funding_history && funding_history.length
            ? funding_history.map(function (_a) {
                var closing_balance = _a.closing_balance, transaction_status = _a.transaction_status, amount = _a.amount, transaction_date = _a.transaction_date, opening_balance = _a.opening_balance, others = __rest(_a, ["closing_balance", "transaction_status", "amount", "transaction_date", "opening_balance"]);
                return (__assign(__assign({}, others), { status: transaction_status === "ACTIVE" ||
                        transaction_status === "SUCCESSFUL"
                        ? "successful"
                        : transaction_status === "INQ"
                            ? "pending"
                            : "failed", amount: formatAmount(amount) || amount, opening_balance: "".concat(formatAmount(opening_balance)), closing_balance: "".concat(formatAmount(closing_balance)), date: "".concat(moment(transaction_date).format("llll")) }));
            })
            : [];
        return __assign(__assign({}, rest), { fundingHistory: fundingHistory, payouts: payouts });
    },
};
